// ─── ページ内ジャンプメニュー ───
export const RECRUIT_SECTIONS = [
  { id: 'message', label: 'メッセージ', icon: 'ri-message-3-line' },
  { id: 'work', label: 'MSKの特徴', icon: 'ri-briefcase-line' },
  { id: 'data', label: 'データで見るMSK', icon: 'ri-bar-chart-2-line' },
  { id: 'voices', label: '社員の声', icon: 'ri-user-voice-line' },
  { id: 'requirements', label: '募集要項', icon: 'ri-file-list-3-line' },
  { id: 'entry-form', label: 'エントリー', icon: 'ri-send-plane-line' },
] as const;

// ─── 平均年齢 年代別ドーナツチャート ───
export const AGE_SEGMENTS = [
  { value: 70,   color: '#89B56B', label: '20代',      pct: '70%'   },
  { value: 23, color: '#AACF85', label: '30代',      pct: '23%' },
  { value: 7, color: '#C8E2A3', label: '40代', pct: '7%' },
];

// ─── データで見るMSK（この数値を変更するとグラフ・チャートも自動更新） ───
export const MSK_DATA_STATS = {
  /** 社員数（名） */
  employeeCount: 32,
  /** 男女比（%） */
  gender: { male: 70, female: 30 },
  /** 平均年齢（歳） */
  averageAge: 28,
  /** 平均残業時間（月/時間） */
  overtime: 10,
  /** 休日形態 */
  holidayStyle: '完全週休2日制',
  /** 休日詳細 */
  holidayDetail: '土日祝休み',
  /** 年間休日数（日） */
  holidayCount: 126,
  /** 離職率（%） */
  turnoverRate: 4,
  /** 離職率 集計期間 */
  turnoverPeriod: '2025年4月〜2026年3月',
} as const;

// ─── 理系/文系比率チャート ───
export const MAJOR_SEGMENTS = [
  { value: 60, color: '#89B56B', label: '文系', pct: '60%' },
  { value: 40, color: '#AACF85', label: '理系', pct: '40%' },
];

// ─── 未経験/経験比率チャート ───
export const EXPERIENCE_SEGMENTS = [
  { value: 60, color: '#89B56B', label: '未経験', pct: '60%' },
  { value: 40, color: '#AACF85', label: '経験', pct: '40%' },
];

// ─── 休日カレンダー表示用 曜日ラベル ───
export const WEEK_DAYS = ['月', '火', '水', '木', '金', '土', '日'] as const;
